export default {
  name: 'Canada',
  phonePattern: '4165551234',
  postalCodePattern: 'A1A1A1',
  singlePostalCode: '',
  postalCodeRegex: '([ABCEGHJKLMNPRSTVXY]\\d)([ABCEGHJKLMNPRSTVWXYZ]\\d){2}',
  language: '',
  dobFormat: 'YY-MM-DD',
  currency: 'cad'
}



// WEBPACK FOOTER //
// ./src/locales/countries/CA.js